import api from '@/utils/api'
import { buildListQuery } from '@/utils/listQuery'

export default {
    getFilteredReferees(filter, page, size, sort) {
        return api.get(`referees` + buildListQuery({ filter, page, size, sort }))
    },

    // every referee (for the match form)
    getAllReferees() {
        return api.get('referees')
    },

    getReferee(id) {
        return api.get(`referees/${id}`)
    },

    createReferee(data) {
        return api.post('referees', data)
    },

    updateReferee(id, data) {
        return api.put(`referees/${id}`, data)
    },

    deleteReferee(id) {
        return api.delete(`referees/${id}`)
    }
}
